import creatorDeposit from "@/tool/creatorDeposit.cjs";

const ACCESS_TOKEN_KEY = "ijust_access_token";
const { clearCreatorDepositIntents } = creatorDeposit;

const getStorage = () => {
    if (typeof window === "undefined") {
        return null;
    }
    return window.sessionStorage;
};

export const getAccessToken = () => {
    const storage = getStorage();
    return storage ? storage.getItem(ACCESS_TOKEN_KEY) : null;
};

export const setAccessToken = (token) => {
    const storage = getStorage();
    if (storage && token) {
        storage.setItem(ACCESS_TOKEN_KEY, token);
    }
};

export const clearAccessToken = () => {
    const storage = getStorage();
    if (storage) {
        storage.removeItem(ACCESS_TOKEN_KEY);
        clearCreatorDepositIntents(storage);
    }
};

export default {
    getAccessToken,
    setAccessToken,
    clearAccessToken,
};
